import api from "./api";
// @ts-expect-error - api is not typed
const { post } = api.getPrefixedMethods("files");
export const filesService = {
    getPresignedUrl: (fileName) => {
        return post("get-presigned-url/", { fileName });
    },
    verifyUpload: (downloadUrl, expectedSize) => {
        return post("verify-upload/", { downloadUrl, expectedSize });
    },
    // LAM-3580/LAM-3649: Image uploads (TIFF, JPEG, PNG) go through this
    // endpoint; the backend converts them to PDF with PyMuPDF before storing
    // in S3. PDFs continue on the faster presigned direct-to-S3 path.
    // _skipPropsAdaptation bypasses the humps decamelizeKeys/camelizeKeys
    // interceptors on both request and response — required so FormData is not
    // destroyed on the way out, and we manually map the snake_case response.
    // We intentionally do NOT pass a filename override to FormData.append —
    // the browser will use file.name, and the backend generates its own UUID
    // prefix for the S3 key (avoids the double-UUID effect of passing the
    // caller-constructed uploadKey through as the filename).
    convertAndUpload: async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        const response = await post("convert-and-upload/", formData, {
            headers: { "Content-Type": "multipart/form-data" },
            _skipPropsAdaptation: true,
            timeout: 120000,
        });
        return {
            downloadUrl: response.download_url,
            uploadKey: response.upload_key,
        };
    },
};
